import { render, staticRenderFns } from "./RequestPage.vue?vue&type=template&id=3adb1a3c&scoped=true&"
import script from "./RequestPage.vue?vue&type=script&lang=js&"
export * from "./RequestPage.vue?vue&type=script&lang=js&"
import style0 from "./RequestPage.vue?vue&type=style&index=0&id=3adb1a3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3adb1a3c",
  null
  
)

export default component.exports